/**
 * Returns a Google Maps search URL for the given query.
 */
const getGoogleMapsSearchUrl = (query: string) =>
	`https://www.google.com/maps/search/?api=1&query=${query}`;

export default getGoogleMapsSearchUrl;
